import { useMutation, useQueryClient } from "react-query";
import { user } from "@/repositories/user";
import { User } from "@/types/v2";
import { useOnUserUpdate } from "@/hooks/queries/usePaginatedUsers";

export const useUpdateUserMutation = () => {
  const queryClient = useQueryClient();
  const onUserUpdate = useOnUserUpdate();

  return useMutation(
    ({ userId, userData }: { userId: string; userData: Partial<User> }) =>
      user.update({ id: userId, ...userData }),
    {
      onSuccess: (_, { userId, userData }) => {
        // Update the specific user query cache immediately
        queryClient.setQueryData<User | undefined>(
          ["users", userId],
          (oldData: User | undefined) => {
            if (!oldData) return undefined;
            return { ...oldData, ...userData };
          }
        );

        onUserUpdate(userId, userData);
      },
    }
  );
};
